module.exports = __webpack_public_path__ + "static/media/brushsan-2.a0ddc6a7.png";